import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import Tooltip from '@material-ui/core/Tooltip';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateKjsName from './ModalForUpdateKjsName';
import ModalForUpdateKjsMunicipality from './ModalForUpdateKjsMunicipality';

class KjsRow extends Component {
  constructor() {
    super();
    this.state = {
      showUpdateKjsName: false,
      showUpdateKjsMunicipality: false,
    };
  }

  handleClose = () => {
    this.setState({
      showUpdateKjsName: false,
      showUpdateKjsMunicipality: false,
    });
  };

  handleOpenModalKjsName = () => {
    this.setState({ showUpdateKjsName: true });
  };

  handleOpenModalKjsMunicipality = () => {
    this.setState({ showUpdateKjsMunicipality: true });
  };

  updateKjs = (updatedKjs) => {
    const {
        updateKjs,
        findAllKjsMunicipalityPageable,
        translations,
        pageNumber,
        pageSize,
      } = this.props || {},
      { NotificationMessages } = translations;
    const notificationMessage = {
      kjs: NotificationMessages.kjs,
      message: NotificationMessages.kjsUpdateNameSuccessefully,
    };
    updateKjs(updatedKjs, this.handleClose, notificationMessage, () =>
      findAllKjsMunicipalityPageable(pageNumber, pageSize)
    );
  };

  updateKjsMunicipality = (updatedKjs) => {
    const { updateKjsWithMunicpality, translations } = this.props || {},
      { NotificationMessages } = translations;
    const notificationMessage = {
      kjs: NotificationMessages.kjs,
      message: NotificationMessages.kjsUpdateMunicipalitySuccessefully,
    };

    updateKjsWithMunicpality(updatedKjs, this.handleClose, notificationMessage);
  };

  onDeactivateClick = () => {
    const { gt, translations, kjs, updateKjs } = this.props || {},
      { NotificationMessages, ConfirmDialog } = translations || {};
    const updatedKjs = { ...kjs, active: false };

    const notificationMessage = {
      kjs: NotificationMessages.kjs,
      message: NotificationMessages.kjsDeactivateSuccessefully,
    };

    const action = () => {
      updateKjs(updatedKjs, () => {}, notificationMessage, true);
    };
    confirmDialog(
      ConfirmDialog.confirmDeactivateMessage,
      action,
      ConfirmDialog.deactivate,
      gt
    );
  };

  onActivateClick = () => {
    const { gt, translations, kjs, updateKjs } = this.props || {},
      { NotificationMessages, ConfirmDialog } = translations || {};
    const updatedKjs = { ...kjs, active: true };

    const notificationMessage = {
      kjs: NotificationMessages.kjs,
      message: NotificationMessages.kjsActivateSuccessefully,
    };

    const action = () => {
      updateKjs(updatedKjs, () => {}, notificationMessage, true);
    };
    confirmDialog(
      ConfirmDialog.confirmActivateMessage,
      action,
      ConfirmDialog.activate,
      gt
    );
  };

  activateDeactivateKjs = (id, onClick, title, iconClassName) => {
    return (
      <td className="text-center">
        <Link id={id} onClick={onClick} to="#">
          <Tooltip title={title} placement="top" arrow={true}>
            <i className={iconClassName} />
          </Tooltip>
        </Link>
      </td>
    );
  };

  render() {
    const {
        index,
        kjsWithMunicipality,
        translations,
        placeList,
        municipalityList,
        kjsList,
        institutionTypeList,
        findAllPlace,
        findAllKjs,
        findAllKjsFilterPageable,
        clearPlaceList,
        clearMunicipalityList,
        findAllMunicipalityByPlace,
        clearKjsList,
      } = this.props || {},
      { kjs, municipality } = kjsWithMunicipality || {},
      { name: kjsName, uniqueNumber, pib } = kjs || {},
      { name: municipalityName } = municipality || {};

    const row = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{kjsName}</td>
        <td>{uniqueNumber}</td>
        <td>{pib}</td>
        <td>{municipalityName}</td>
        <td>
          <Link onClick={this.handleOpenModalKjsMunicipality} to="#">
            <Tooltip
              title={translations.Tooltips.updateMunicipality}
              placement="top"
              arrow={true}
            >
              <i className="fas fa-pen-nib"></i>
            </Tooltip>
          </Link>
        </td>
        <td>
          <Link onClick={this.handleOpenModalKjsName} to="#">
            <Tooltip
              title={translations.Tooltips.update}
              placement="top"
              arrow={true}
            >
              <i className="fas fa-edit fa-2x" />
            </Tooltip>
          </Link>
        </td>
      </tr>
    );

    return (
      <Fragment>
        {row}
        {this.state.showUpdateKjsName && (
          <ModalForUpdateKjsName
            show={this.state.showUpdateKjsName}
            handleClose={this.handleClose}
            kjs={kjs}
            updateKjs={this.updateKjs}
          />
        )}
        {this.state.showUpdateKjsMunicipality && (
          <ModalForUpdateKjsMunicipality
            show={this.state.showUpdateKjsMunicipality}
            handleClose={this.handleClose}
            kjsWithMunicipality={kjsWithMunicipality}
            updateKjs={this.updateKjs}
            placeList={placeList}
            municipalityList={municipalityList}
            kjsList={kjsList}
            institutionTypeList={institutionTypeList}
            clearPlaceList={clearPlaceList}
            clearMunicipalityList={clearMunicipalityList}
            findAllPlace={findAllPlace}
            findAllKjs={findAllKjs}
            findAllKjsFilterPageable={findAllKjsFilterPageable}
            findAllMunicipalityByPlace={findAllMunicipalityByPlace}
            clearKjsList={clearKjsList}
            updateKjsMunicipality={this.updateKjsMunicipality}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(KjsRow, 'KjsRow');
